import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  btns: {
    margin: theme.spacing(0, 1)
  }
}));
